<template>
  <component
    v-if="state && state.actionType !== 'none'"
    :is="state.link ? 'a' : RouterLink"
    :href="state.link"
    :to="state.route"
    :class="buttonClass"
  >
    <FontAwesomeIcon v-if="state.icon" class="px-1" :icon="state.icon" />
    {{ state.text }}
  </component>
</template>

<script setup lang="ts">
import { RouterLink } from "vue-router";
import type { FollowupState } from "@/composables/useFollowupState";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

withDefaults(
  defineProps<{
    state: FollowupState;
    buttonClass?: string;
  }>(),
  { buttonClass: "btn btn-primary" }
);
</script>
